const store = new Map();
const DEFAULT_TTL = 60 * 1000;

function isFresh(entry, ttl) {
  return entry && Date.now() - entry.at < ttl;
}

export function cached(key, loader, ttl = DEFAULT_TTL) {
  const hit = store.get(key);
  if (isFresh(hit, ttl)) {
    return hit.promise;
  }

  const entry = { at: Date.now(), resolved: false, data: undefined };
  entry.promise = loader()
    .then((data) => {
      entry.resolved = true;
      entry.data = data;
      return data;
    })
    .catch((error) => {
      store.delete(key);
      throw error;
    });
  store.set(key, entry);
  return entry.promise;
}

export function peek(key, ttl = DEFAULT_TTL) {
  const hit = store.get(key);
  return isFresh(hit, ttl) && hit.resolved ? hit.data : undefined;
}
